module.exports = __webpack_public_path__ + "img/clams.2bc59802.svg";